import { API_PAYMENTS_URL } from '@/constants/config';
import { fetch } from '@/utils/fetch';

interface SplitPaymentsBasePayload {
  totalAmount: number;
  currency: string;
  reference: string;
  webhookUrl: string;
}

type SplitPaymentsPayload = SplitPaymentsBasePayload &
  (
    | { type: 'SPLIT_EQUALLY'; numberOfSplits: number }
    | { type: 'SPLIT_BY_ITEMS'; lineItemIds: string[] }
  );

interface SplitPaymentsResponse {
  success: boolean;
  message?: string;
}

export const createSplit = (payload: SplitPaymentsPayload) =>
  fetch<SplitPaymentsResponse>({
    method: 'POST',
    url: `${API_PAYMENTS_URL}/split-payments`,
    data: payload,
  });
